import React from 'react';
import { ShieldCheck, MapPin, DollarSign, CalendarCheck } from 'lucide-react';


const WhyChooseUs = () => {
    return (
       <section id="why-choose-us" className="py-24 bg-[#f4f7f5]">
            <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-6xl">
                
                {/* Section Header */}
                <div className="text-center mb-16">
                    <h2 className="text-3xl md:text-5xl font-extrabold text-gray-900 mb-4">Earn Passive Income Sharing Your Home EV Charger</h2>
                    <p className="text-gray-600 text-lg max-w-3xl mx-auto">PeerchargeEV's dynamic, community-driven solution layer is the infra behind Bharat's EV shift.</p>
                </div>

                <div className="space-y-16">
                    {/* Feature Card 1 */}
                    <div className="bg-brand-light rounded-[2.5rem] p-8 md:p-12 lg:p-16 flex flex-col lg:flex-row items-center gap-12 border border-gray-100">
                        <div className="flex-1 lg:pr-8">
                            <h3 className="text-3xl font-bold text-gray-900 mb-6">Charging Everywhere</h3>
                            <p className="text-gray-600 text-lg mb-8 leading-relaxed">
                                Access a vast, community-powered network of chargers in your neighborhood and beyond. No more range anxiety.
                            </p>
                            <div className="space-y-4">
                                <div className="flex items-center gap-3">
                                    <MapPin className="text-brand-green" size={24} />
                                    <span className="text-gray-800 font-medium">Find chargers nearby</span>
                                </div>
                                <div className="flex items-center gap-3">
                                    <ShieldCheck className="text-brand-green" size={24} />
                                    <span className="text-gray-800 font-medium">Verified hosts</span>
                                </div>
                            </div>
                        </div>
                        <div className="flex-1 w-full relative">
                            <div className="aspect-[4/3] bg-white rounded-3xl shadow-xl border border-gray-200 overflow-hidden flex items-center justify-center relative p-6">
                                {/* Abstract Map/UI Graphic */}
                                <div className="absolute inset-0 bg-gray-50 opacity-50 bg-[radial-gradient(#e5e7eb_1px,transparent_1px)] [background-size:16px_16px]"></div>
                                <div className="relative z-10 w-full h-full bg-white rounded-2xl shadow-sm border border-gray-100 p-4">
                                   <div className="w-full h-32 bg-green-50 rounded-xl mb-4 flex items-center justify-center">
                                       <MapPin className="text-brand-green w-12 h-12" />
                                   </div>
                                   <div className="h-4 bg-gray-100 rounded-full w-3/4 mb-3"></div>
                                   <div className="h-4 bg-gray-100 rounded-full w-1/2"></div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Feature Card 2 */}
                    <div className="bg-brand-light rounded-[2.5rem] p-8 md:p-12 lg:p-16 flex flex-col-reverse lg:flex-row items-center gap-12 border border-gray-100">
                        <div className="flex-1 w-full relative">
                            <div className="aspect-[4/3] bg-white rounded-3xl shadow-xl border border-gray-200 overflow-hidden flex items-center justify-center relative p-6">
                                <div className="relative z-10 w-full h-full bg-white rounded-2xl shadow-sm border border-gray-100 p-4 flex flex-col justify-end">
                                   <div className="w-full flex items-end gap-2 h-32 border-b border-gray-100 pb-2 mb-4">
                                        <div className="w-1/6 bg-green-100 rounded-t-md h-1/3"></div>
                                        <div className="w-1/6 bg-green-200 rounded-t-md h-2/3"></div>
                                        <div className="w-1/6 bg-brand-green rounded-t-md h-full"></div>
                                        <div className="w-1/6 bg-green-200 rounded-t-md h-1/2"></div>
                                        <div className="w-1/6 bg-green-100 rounded-t-md h-3/4"></div>
                                   </div>
                                   <div className="h-4 bg-gray-100 rounded-full w-full"></div>
                                </div>
                            </div>
                        </div>
                        <div className="flex-1 lg:pl-8">
                            <h3 className="text-3xl font-bold text-gray-900 mb-6">Earn Passive Income</h3>
                            <p className="text-gray-600 text-lg mb-8 leading-relaxed">
                                Turn your unused home charger into a revenue stream. You set your own price, schedule, and availability.
                            </p>
                            <div className="space-y-4">
                                <div className="flex items-center gap-3">
                                    <DollarSign className="text-brand-green" size={24} />
                                    <span className="text-gray-800 font-medium">Set your own rates</span>
                                </div>
                                <div className="flex items-center gap-3">
                                    <CalendarCheck className="text-brand-green" size={24} />
                                    <span className="text-gray-800 font-medium">Control your schedule</span>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    );
};

export default WhyChooseUs;